<angular2-multiselect
    class="custom-multi-select-dropdown"
    [data]="data"
    [(ngModel)]="inputModel"
    [disabled]="disabled"
    [settings]="multiDropdownSettings"
    [(ngModel)]="inputModel"
    (ngModelChange)="inputModelChangeEvent(inputModel)"
    [ngModelOptions]="{ standalone: true }"
></angular2-multiselect>
<span *ngIf="showMessageError" class="error invalid-feedback d-block ng-star-inserted">
    {{ 'ThisFieldIsRequired' | localize }}
</span>
